import { PaginatedData } from "../hooks/PaginationHooks";
import {
    GenericInAppNotification,
    GenericInAppNotificationDetailResponse,
    GenericInAppNotificationResponse,
    NotificationWithPagination,
    GenericInAppNotificationFilterParameters
} from "../types/notificationType";
import { PaginationParameters, toQueryParameters } from "./Pagination";
import {CallResult, doApiDelete, doApiGet, doApiPatch, doApiPost, doApiPostFormData} from "./Requests";


export const notificationApi = {
    getUnreadNotificationAmount: (): Promise<CallResult<number>> =>
        doApiGet<number>(`/api/users/current/notifications/count`),

    getNotificationList: (
        offset: number,
        limit: number,
        status: string
    ): Promise<CallResult<NotificationWithPagination>> =>
        doApiGet<NotificationWithPagination>(
            `/api/users/current/notifications?offset=${offset}&limit=${limit}&status=${status}`
        ),

    editNotificationVisibility: (
        id: number,
        status: string
    ): Promise<CallResult<void>> =>
        doApiPatch<string, void>(`/api/users/current/notifications/${id}/status`, status),

    getGenericInAppNotifications: (
        pagination: PaginationParameters,
        filters: GenericInAppNotificationFilterParameters = {}
    ): Promise<CallResult<PaginatedData<GenericInAppNotificationResponse>>> => {
        const filterParams = [
            ...(filters.createdFrom ? [`&createdFrom=${encodeURIComponent(filters.createdFrom)}`] : []),
            ...(filters.createdTo ? [`&createdTo=${encodeURIComponent(filters.createdTo)}`] : []),
        ].join('');
        return doApiGet<PaginatedData<GenericInAppNotificationResponse>>(
            `/api/companies/current/notifications?${toQueryParameters(pagination)}${filterParams}`
        );
    },

    getGenericInAppNotification: (id: number): Promise<CallResult<GenericInAppNotificationResponse>> =>
        doApiGet<GenericInAppNotificationResponse>(`/api/companies/current/notifications/${id}`),

    getGenericInAppNotificationDetail: (id: number): Promise<CallResult<GenericInAppNotificationDetailResponse>> =>
        doApiGet<GenericInAppNotificationDetailResponse>(`/api/companies/current/notifications/${id}/details`),

    createGenericInAppNotification: (updatedNotification: GenericInAppNotification): Promise<CallResult<number>> =>
        doApiPost<GenericInAppNotification, never>(`/api/companies/current/notifications`, updatedNotification),

    updateGenericInAppNotification: (id: number, updatedNotification: GenericInAppNotification): Promise<CallResult<void>> =>
        doApiPatch<GenericInAppNotification, never>(`/api/companies/current/notifications/${id}`, updatedNotification),

    deleteGenericInAppNotification: (id: number): Promise<CallResult<void>> =>
        doApiDelete<never>(`/api/companies/current/notifications/${id}`),

    uploadNotificationImage: (id: number, file: File): Promise<CallResult<string>> => {
        const formData = new FormData();
        formData.append("file", file);
        return doApiPostFormData<string>(`/api/companies/current/notifications/${id}/image`, formData);
    },
    deleteNotificationImage: (id: number, imageId: number): Promise<CallResult<void>> =>
        doApiDelete<void>(`/api/companies/current/notifications/${id}/image/${imageId}`),
};